import CalloutBuilder from "./CalloutBuilder";
import CalloutBuilderMock from "./CalloutBuilderMock";
import Constants from 'utilities/js/Constants';
import {decodeJSONString, encodeJSONObject} from '../bracket/JSONEncoder';
import {addRecentViewBracket} from "../localstorage/StorageHelper_ViewBrackets";

let calloutBuilder = Constants.MOCK_API ? new CalloutBuilderMock() : new CalloutBuilder();


export async function getViewOnlyBracket(key){
    let result = await calloutBuilder.getViewOnlyBracket(key);
    
    result.bracket = decodeJSONString(result.bracket);
    if(result.doubleElimBracket){
        result.doubleElimBracket = decodeJSONString(result.doubleElimBracket);
    }
    result.contestants = decodeJSONString(result.contestants);

    
    if(result.bracket){
        addRecentViewBracket(key, {title: result.title, lastdate: new Date().getTime(), created_by: {id: result?.created_by?._id, username: result?.created_by?.username}})
    }   
    return result;
}

export async function getAdminBracket(key){
    let result = await calloutBuilder.getAdminBracket(key);
    
    result.bracket = decodeJSONString(result.bracket);
    if(result.doubleElimBracket){
        result.doubleElimBracket = decodeJSONString(result.doubleElimBracket);
    }
    result.contestants = decodeJSONString(result.contestants);
    return result;
}

export function getBrackets(params){
    return calloutBuilder.getBrackets(params);
}

export function createBracket(bracketInfo){
    
    if(bracketInfo.bracket){
        bracketInfo.bracket = encodeJSONObject(bracketInfo.bracket);
    }
    if(bracketInfo.doubleElimBracket){
        bracketInfo.doubleElimBracket = encodeJSONObject(bracketInfo.doubleElimBracket);
    }
    if(bracketInfo.contestants){
        bracketInfo.contestants = encodeJSONObject(bracketInfo.contestants);
    }
    return calloutBuilder.createBracket(bracketInfo);
}

export function updateBracket(bracketInfo){
    
    if(bracketInfo.bracket){
        bracketInfo.bracket = encodeJSONObject(bracketInfo.bracket);
    }
    if(bracketInfo.doubleElimBracket){
        bracketInfo.doubleElimBracket = encodeJSONObject(bracketInfo.doubleElimBracket);
    }
    if(bracketInfo.contestants){
        bracketInfo.contestants = encodeJSONObject(bracketInfo.contestants);
    }
    return calloutBuilder.updateBracket(bracketInfo);
}

export function deleteBracket(body){
    return calloutBuilder.deleteBracket(body);
}

//********************** Search features **********************//

export function search(params){
    return calloutBuilder.search(params);
}

//********************** Follow features **********************//

export function getAccountInfo(params){
    return calloutBuilder.getAccountInfo(params);
}

//********************** Login features **********************//
export function login(params){
    return calloutBuilder.login(params);
}

export function registerUser(params){
    return calloutBuilder.registerUser(params);
}

export function getUserInfo(key){
    return calloutBuilder.getUserInfo(key);
}
export function verifyEmail(key){
    return calloutBuilder.verifyEmail(key);
}
export function sendVerifyEmail(key){
    return calloutBuilder.sendVerifyEmail(key);
}
export function sendResetPasswordEmail(key){
    return calloutBuilder.sendResetPasswordEmail(key);
}
export function resetPassword(params){
    return calloutBuilder.resetPassword(params);
}
export function getResetPassword(key){
    return calloutBuilder.getResetPassword(key);
}

//********************** Account features **********************//
export function updateAccount(body){
    return calloutBuilder.updateAccount(body);
}
export function getAccountColors(params){
    return calloutBuilder.getAccountColors(params);
}

//********************** Notification features **********************//
export function getNotifications(params){
    return calloutBuilder.getNotifications(params);
}
export function updateNotifications(body){
    return calloutBuilder.updateNotifications(body);
}
export function markNotificationsAsRead(body){
    return calloutBuilder.markNotificationsAsRead(body);
}
export function clearNotifications(body){
    return calloutBuilder.clearNotifications(body);
}

//********************** Feedback features **********************//
export function submitFeedback(params){
    return calloutBuilder.submitFeedback(params);
}


//********************** Follow features **********************//
export function getFollow(params){
    return calloutBuilder.getFollow(params);
}

export function createFollow(body){
    return calloutBuilder.createFollow(body);
}

export function removeFollow(body){
    return calloutBuilder.removeFollow(body);
}

export function getFollowCount(params){
    return calloutBuilder.getFollowCount(params);
}

export function getFollows(params){
    return calloutBuilder.getFollows(params);
}

export function approveFollowRequest(body){
    return calloutBuilder.approveFollowRequest(body);
}
export function declineFollowRequest(body){
    return calloutBuilder.declineFollowRequest(body);
}